
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions'; // Import functions service
import { getMessaging } from 'firebase/messaging';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyABXi8mBtE7AjPCEoZaNCA2gdMtkm4KrgU",
  authDomain: "reseye-a4452.firebaseapp.com",
  databaseURL: "https://reseye-a4452.firebaseio.com",
  projectId: "reseye-a4452",
  storageBucket: "reseye-a4452.appspot.com",
  messagingSenderId: "555325866579",
  appId: "1:555325866579:web:b877313ad344064ec27ca6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app); // Export functions service
export const messaging = getMessaging(app);

